<template>
  <div class="col col-md-12 p-0" id="edit-textpage">
    <div id="photodoku">
      <div class="innerdoc template2 position-relative">
        <div class="header col-md-12">
          <div class="row">
            <div class="col-md-6 pl-lg-0">
              <img :src="logo_one" class="mb-2 img-fluid logo-images-in-docs" alt="img">
            </div>
            <div class="col-md-6 text-right">
              <img :src="logo_two" class="mb-2 img-fluid logo-images-in-docs" alt="img">
            </div>
          </div>
        </div>
        <div class="clearfix"></div>

        <div class="picdetail">
          <div class="text-center">
            <h3 class="text-center mb-2">Zusammenfassung</h3>
            <textarea v-model="doc.description" class="form-control"></textarea>
          </div>
        </div>
        <p class="text-center border-top position-absolute foot pb-2">
          Seite 2  von {{ Math.ceil(images.length / 2) + 2 }}
          <span class="float-right">projectdocu.com</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import {setAspectRatio} from '../../common'
export default {
  props: ['logo_one','logo_two'],
  mounted () {
    setAspectRatio()
  },
  computed: {
    theme () {
      return this.$store.state.photoDocumentation.selectedTemplate
    },
    doc(){
      if (this.$route.name === 'photoDocumentEdit'){
        return  this.$store.state.photoDocumentation.selectedDocument
      }else {
        return this.$store.state.photoDocumentation.newDocumentDetails
      }
    },
    images () {
      if (this.doc.reporttype == '0'){
        return this.$store.state.photoDocumentation.dailyReportPhotos
      }else {
        return this.$store.state.photoDocumentation.selectedImages
      }
    },
  }
}
</script>
<style scoped>
.innerdoc.template2 textarea{
  aspect-ratio: 1.15 / 1;
}
</style>



// WEBPACK FOOTER //
// src/components/photoDocumentation/components/TextareaTab.vue